<template>
	<main v-if="info">
		<div class="main">
      <dl class="titleTip">
        <dt>
          <span  style="color:#666;cursor: pointer" @click="$router.go(-1)">辐射安全 ></span>
          <span> 辐射安全详情</span>
        </dt>
        <dd></dd>
      </dl>
			<div class="mainBox">
				<h2>{{info.name}}</h2>
        <div class="time">
          {{info.time}}
        </div>
				<div class="content" v-html="info.content">
        </div>
			</div>
		</div>
	</main>
</template>
<script>
  import $ from 'jquery'
	export default {
		name: 'Article',
		data() {
			return {
				name: '',
				time: '',
				content: '',
        ClinicalId: '',
        dateList: [],
        info: null
			}
		},
		created() {
			const ClinicalId = this.$route.query.ClinicalId;
			this.ClinicalId = ClinicalId;
			this.getArticleDtails();
		},
		methods: {
      showImg(url) {
        var imgid = Math.random(),frameid = 'frameimg' + imgid;
        window['img'+imgid] = '<img id="img" src=\''+url+'\' />' +
          '<script>window.onload = function(){' +
          // 'parent.document.getElementById(\''+frameid+'\').width=document.getElementById(\'img\').width+\'px\';' +
          // 'parent.document.getElementById(\''+frameid+'\').height=document.getElementById(\'img\').height+\'px\';' +
          'let width=document.getElementById(\'img\').width;' +
          'parent.document.getElementById(\''+frameid+'\').width=\'100%\';' +
          'parent.document.getElementById(\''+frameid+'\').objectFit=\'cover\';' +
          'var root = document.querySelector("body");' +
          'var img = document.querySelector("img");' +
          'root.style.textAlign = "center";' +
          'img.style.maxWidth = "100%";' +
          'parent.document.getElementById(\''+frameid+'\').height=document.getElementById(\'img\').height + \'px\';' +
          'console.log(img.clientWidth / width)' +
          '}<'+'/script>';
        return '<iframe id="'+frameid+'" src="javascript:parent[\'img'+imgid+'\'];" frameBorder="0" scrolling="no" width="100%"></iframe>';
      },
      changeImg() {
        var imgs = document.querySelectorAll('.content img');
        // console.log(imgs)
        for(var i=0;i<imgs.length;i++){
          var data_src = $(imgs[i]).attr("data-src");
          if (!data_src) {
            return
          }
          var html = this.showImg(data_src);
          $(imgs[i]).replaceWith(html);
        }
      },
			getArticleDtails() {
				const articleId = this.ClinicalId;
				const params = {
          ClinicalId: this.ClinicalId,
				}
				this.$api.getRadiateDataList(params).then(r => {
					if (r.code === 1) {
						this.dateList = r.data.data
            let o = this.dateList.find((v) => {
              return v.id == this.ClinicalId
            })
            console.log(o)
            this.info = o
            this.$nextTick(() => {
              this.changeImg()
            })
					}
				})
			},
		},
		computed: {

		},
		watch: {

		},
	}

</script>
<style lang="scss" scoped>
	@import './radiateList.scss';
</style>
